export const receiptsStates = {
  1: { label: 'Emitido', color: 'gray' },
  2: { label: 'Facturado', color: 'success' },
  3: { label: 'ReAdjudicado', color: 'orange' },
  4: { label: 'Anulado', color: 'orange' }
};

export const receiptsCodeStates = {
  emitido: 1,
  facturado: 2,
  readjudicado: 3,
  anulado: 4
};

export const INVOICE_STATES = [receiptsCodeStates.emitido];

export const CANCEL_STATES = [
  receiptsCodeStates.emitido,
  receiptsCodeStates.facturado
];
